export default __webpack_public_path__ + "./img/img_success.jpg";